var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2935_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.043 0C5.00113 0 0 4.9152 0 10.957C0 16.9989 5.00113 22 11.043 22C17.0848 22 22 16.9989 22 10.957C22 4.9152 17.0848 0 11.043 0ZM14.9927 11.519L9.13378 17.3779C8.85169 17.66 8.39437 17.66 8.11229 17.3779L7.31096 16.5766C7.02887 16.2945 7.02887 15.8372 7.31096 15.5551L11.3458 11.5203C11.6561 11.21 11.654 10.7062 11.341 10.3986L7.31964 6.44484C7.03347 6.16348 7.03153 5.70281 7.3153 5.41905L8.11546 4.61888C8.39631 4.33804 8.85118 4.33662 9.13374 4.6157L14.9892 10.3986C15.301 10.7064 15.3025 11.2092 14.9927 11.519Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2935_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/send-arrow.1d258c340e9a8c99a2dff2a498ee1550.svg";
export { ForwardRef as ReactComponent };